import type {NodeBaseMixin, NodeType} from "#magnolia-layer/types/magnolia-types";
import type {PublicationRoot} from "~/types/mgnl";

export function mapNodes<
    ReturnType extends NodeBaseMixin<NodeType> = PublicationRoot,
    _NodeType extends NodeType = "mgnl:folder",
    ChildNodeType extends NodeType = "mgnl:folder" | "somfy:publication",
    FolderType extends NodeType = "mgnl:folder"
>(node: NodeBaseMixin<NodeType>, folderNodeType: FolderType = "mgnl:folder" as FolderType): ReturnType {
    node.children = [];
    for (let nodeName of node["@nodes"]) {
        const child = node[nodeName] as NodeBaseMixin<ChildNodeType>;
        if (node["@nodeType"] === folderNodeType && child["@nodes"].length > 0) {
            node.children.push(mapNodes(child as NodeBaseMixin<NodeType>, folderNodeType));
        } else {
            node.children.push(child);
        }
    }
    return node as ReturnType;
}
